import { supabase } from "@/services/supabase/createClient";
import { useQuery } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";

const productInfos = {
  "b81ca2b1-fac5-4221-8481-eb9af89e38bd": {
    title: "Pro",
    description:
      "Best if you want to use Prompt Studio for your team. Get more control over your results with knowledge bases and custom AI behaviors.",
    features: [
      "30 monthly credits included",
      "Organize your promptbooks in workspaces",
      "Collaborate with your team members",
      "Role-based access",
      "Advanced AI behaviors",
      "Build custom behavior presets (Soon)",
      "Run your Promptbooks in batches (Soon)",
      "Build custom templates (Soon)",
      "Setup knowledge bases (Soon)",
      "Community support",
    ],
    prices: {
      monthly: 4900,
      yearly: 49000,
    },
  },
};

const getProducts = async () => {
  const [{ data: products, error: productsError }, { data: prices, error: pricesError }] = await Promise.all([
    supabase.from("products").select("*"),
    supabase.from("prices").select("*"),
  ]);

  if (productsError) {
    Sentry.captureException(productsError);
    throw new Error(productsError.message);
  }

  if (pricesError) {
    Sentry.captureException(pricesError);
    throw new Error(pricesError.message);
  }

  const productWithPrices = products?.map((product) => {
    const productPrices = prices?.filter((price) => price.product_id === product.product_id);
    return {
      ...product,
      prices: productPrices,
      info: productInfos[product.product_id as keyof typeof productInfos],
    };
  }, {});

  return productWithPrices;
};

export const useProducts = () => {
  return useQuery({
    queryKey: ["products"],
    queryFn: getProducts,
  });
};
